module.exports = __webpack_public_path__ + "images/category_lp/common/sticky_estimate_button/flat_gold_ee3f03fae7e41552ada4800cc776c508.png";